module.exports = __webpack_public_path__ + "img/black-full-logo.adf49872.png";